/**
 * PublicAdminOnboardingPage.jsx
 * ==============================
 *
 * Slideshow d'onboarding ADMIN. Auth requise (staff interne).
 * Route : /docs/admin/onboarding
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import OnboardingSlideshow from '../../components/docs/OnboardingSlideshow';
import { ADMIN_ONBOARDING_SLIDES } from '../../components/docs/AdminOnboardingSlidesData';
import { PermissionDenied } from '../../components/permissions/RequirePermission';
import { usePermissions } from '../../contexts/PermissionsContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const PublicAdminOnboardingPage = () => {
  const navigate = useNavigate();
  const { isAdmin, hasAnyPermission } = usePermissions();
  const isStaff =
    isAdmin ||
    hasAnyPermission([
      'operations.view.all',
      'finances.view.all',
      'reports.view_dashboard',
    ]);

  if (!isStaff) {
    return (
      <div className="min-h-screen bg-slate-50 p-6 flex items-center justify-center" data-testid="admin-onboarding-denied">
        <div className="max-w-lg w-full">
          <PermissionDenied
            title="Onboarding réservé au personnel interne"
            hint="Si vous êtes un client, consultez l'onboarding via /docs/client/onboarding."
          />
        </div>
      </div>
    );
  }

  return (
    <div data-testid="public-admin-onboarding-page">
      <OnboardingSlideshow
        slides={ADMIN_ONBOARDING_SLIDES}
        onClose={() => navigate('/docs/admin')}
        pdfDownloadUrl={`${BACKEND_URL}/api/uploads/docs/Formation_Admin_Baobab_Connect.pdf`}
      />
    </div>
  );
};

export default PublicAdminOnboardingPage;
